<template>
    <div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.vehicle') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.vehicle")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>

        <div class="content">
            <div class="container-fluid">

                <!-- <div class="callout callout-success">
                    <br>
                    <workflow-process />
                </div> -->

                <div class="card card-default">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-6 col-6">
                                <h3 class="card-title mt-1">{{ $t("label.vehicle")}}</h3>
                            </div>
                            <div class="col-md-6 col-6 text-right">
                                <router-link class="btn btn-sm btn-primary" to="/vehicle/create">
                                    <fa :icon="fas.faPlus" /> {{ $t('label.create') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-4">
                                <div class="input-group">
                                    <input @keyup.enter="getVehicles(1)" type="text" class="form-control" autofocus v-model="search" :placeholder="$t('label.search')">
                                    <div @click="getVehicles(1)" class="input-group-append cursor-pointer">
                                        <span class="input-group-text">
                                            <fa :icon="fas.faSearch"/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="vehicles.length > 0" class="table-responsive">
                            <table class="table table-bordered mb-0">
                                <tbody>
                                    <tr>
                                        <th nowrap style="width: 1%;"></th>
                                        <th>{{ $t('label.plate_number') }}</th>
                                        <th>{{ $t('label.brand') }}</th>
                                        <th>{{ $t('label.color') }}</th>
                                        <th>{{ $t('label.type') }}</th>
                                        <th>{{ $t('label.year') }}</th>
                                        <th nowrap style="width: 1%;"></th>
                                    </tr>
                                    <tr v-for="(vehicle, index) in vehicles" :key="index">
                                        <td>{{ index + 1}}</td>
                                        <td>{{ vehicle.plate_number }}</td>
                                        <td>{{ vehicle.brand }}</td>
                                        <td>{{ vehicle.color }}</td>
                                        <td>{{ vehicle.type_name }}</td>
                                        <td>{{ vehicle.year }}</td>
                                        <td nowrap style="width: 1%;">
                                            <router-link v-if="$hasPermission('tempvehicle.vehicle.view')" :to="{name : 'VehicleDetail', params: { id: vehicle.uuid }}" class="mr-1" :title="$t('label.view')">
                                                <fa :icon="fas.faEye" style="color: #007bff;"/>
                                            </router-link>
                                            <router-link v-if="$hasPermission('tempvehicle.vehicle.edit')" :to="{ name: 'EditVehicle', params: { id: vehicle.uuid }}" class="mr-1" :title="$t('label.edit')">
                                                <fa :icon="fas.faEdit" style="color: green;"/>
                                            </router-link>
                                            <a v-if="$hasPermission('tempvehicle.vehicle.delete')" v-on:submit.prevent @click="deleteVehicle(vehicle.uuid)" :title="$t('label.delete')" href="javascript:void(0)">
                                                <fa :icon="fas.faTrash" style="color: red;"/>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="vehicles.length > 0">
                              <paginate class="pagination-sm mb-0"
                                        :page-count="last_page"
                                        :force-page="forcePage"
                                        :page-range="3"
                                        :margin-pages="2"
                                        :click-handler="getVehicles"
                                        :container-class="'pagination float-right'"
                                        :prev-text="'Prev'"
                                        :prev-class="'page-item'"
                                        :next-text="'Next'"
                                        :next-class="'page-item'"
                                        :page-class="'page-item'"
                                        :active-class="'active'"
                                        :prev-link-class="'page-link'"
                                        :next-link-class="'page-link'"
                                        :page-link-class="'page-link'"
                                        ref="vehicle">
                              </paginate>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-md-12">
                                <div class="callout callout-success">
                                    <label>{{$t('label.no_data')}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
    name: 'Vehicles',
    data() {
        return {
            baseURI: "",
            imageBaseUrl : "",
            srcImage : "",
            srcPdf : "",
            vehicles: [],
            vehicle_uuid:"",
            search: "",
            forcePage: 1,
            last_page: 0,
        }
    },
    computed: {
        fas() {
            return fas;
        },
    /* filteredVehicles(){
            return this.vehicles.filter(vehicle => {
                let search = this.search.toLowerCase();
                return vehicle.plate_number.toLowerCase().includes(search)
                    || vehicle.brand.toLowerCase().includes(search)
                    || vehicle.frame_number.toLowerCase().includes(search)
                    || vehicle.engine_number.toLowerCase().includes(search)
                    || vehicle.color.toLowerCase().includes(search)
                    || vehicle.year.toString().includes(search)
                    || vehicle.type_name.toLowerCase().includes(search)
            });
        }*/
    },
    mounted() {
        this.getVehicles();
        this.imageBaseUrl = process.env.VUE_APP_BACKEND_API_URL + "/";
    },
    methods: {
        getVehicles(pageNumber = 1) {
          this.$store.state.loading.status = true;
          this.forcePage = pageNumber;
          this.forcePage = pageNumber;
          let url = this.baseURI + 'vehicles?page=' + pageNumber + '&per_page=' + 10;
          if(this.search){
            url = url + '&search=' + this.search;
          }
          GDCE_Client.requestApi("GET",url).then(response => {
              this.vehicles = response.data.data;
              this.last_page = response.data.last_page;
              this.$store.state.loading.status = false;
          }).catch(()=>{});
        },
        addVehicle() {
            this.vehicle_uuid = "";
            $("#vehicleModal").modal("show");
        },
        editVehicle(uuid) {
            this.vehicle_uuid = uuid;
            this.$nextTick(function() {
                setTimeout(function() {
                    $("#vehicleModal").modal("show");
                }, 500);
            })
        },
        deleteVehicle(uuid){
            this.$swal({
                title: this.$t('label.confirm'),
                text: this.$t('label.confirm_delete'),
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    let url = this.baseURI+'/vehicles/'+ uuid;
                    GDCE_Client.requestApi("DELETE",url).then(response => {
                        if(response.status){
                            this.getVehicles();  
                        }
                    }).catch(()=>{});
                }
            });
        }
    }
}
</script>
<style scoped>
    .modal {
		display: none; /* Hidden by default */
		position: fixed; /* Stay in place */
		z-index: 1; /* Sit on top */
		padding-top: 15px; /* Location of the box */
		left: 0;
		top: 0;
		width: 100%; /* Full width */
		height: 100%; /* Full height */
		overflow: auto; /* Enable scroll if needed */
		background-color:   rgba(0, 0, 0, 0.03); /* Black w/ opacity */
	}
	/* Modal Content (image) */
	.modal-content {
		margin: auto;
		display: block;
		width: 80%;
		max-width: 800px;
	}
	/* Add Animation */
	.modal-content,
	#caption {
		-webkit-animation-name: zoom;
		-webkit-animation-duration: 0.6s;
		animation-name: zoom;
		animation-duration: 0.6s;
	}
	@-webkit-keyframes zoom {
		from {
			-webkit-transform: scale(0);
		}
		to {
			-webkit-transform: scale(1);
		}
	}
	@keyframes zoom {
		from {
			transform: scale(0);
		}
		to {
			transform: scale(1);
		}
	}
	/* The Close Button */
	.close-image {
		color: #dddddd;
		font-weight: bold;
		transition: 0.3s;
        float : right;
        font-size: 16px;
        background-color: rgba(146, 0, 0, 0.966);
        border-radius: 15px;
        width: 30px;
        height: 30px;
        margin-top: -15px;
        margin-right: -15px;
        text-align: center;
        line-height: 30px;
	}
	.close-image:hover,
	.close-image:focus {
        background-color: rgba(175, 0, 0, 0.966);
		color: rgb(0, 0, 0);
		text-decoration: none;
		cursor: pointer;
	}
    .show-image-dialog {
        width: 100%;
        padding: 10px;
    }
	/* 100% Image Width on Smaller Screens */
	@media only screen and (max-width: 700px) {
		.modal-content {
			width: 100%;
		}
    }
    
    table tbody tr td,
    table thead tr th {
        white-space: nowrap;
        word-wrap: normal;
    }
    table tbody tr td a, table tr td a {
        display: inline;
        white-space: nowrap;
        padding-left: 5px;
    }
</style>